/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
// eslint-disable-next-line no-unused-vars
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import React from 'react';

import LandingPage from 'pages/LandingPage';
import ProjectPage from 'pages/ProjectPage';
import ProjectDetailPage from 'pages/ProjectDetailPage';
import TeamPage from 'pages/TeamPage';
import DiscussProjectPage from 'pages/DiscussProjectPage';
import Pricing from 'pages/Pricing';
import NotFoundPage from 'pages/NotFoundPage';
import PricingMobile from 'pages/PricingMobile';
import ForEliteEntrepenuers from 'pages/ForEliteEntrepenuers';
import ProfitMarginPage from 'pages/ProfitMarginPage';
import InvoiceGeneratorPage from 'pages/InvoiceGenerator';
import ContentRepurposingServices from 'pages/ContentRepurposingServices/ContentRepurposingServices';
import ThankYou from 'pages/ContentRepurposingServices/ConfimationPageContentService';

import 'assets/css/styles.css';
import ProjectPlanner from 'pages/ProjectPlanner';

function App() {
  return (
    <Switch>
      <Route exact path="/" component={LandingPage} />
      <Route exact path="/projects" component={ProjectPage} />
      <Route exact path="/projects/:id" component={ProjectDetailPage} />
      <Route exact path="/tools" component={ForEliteEntrepenuers} />
      <Route exact path="/about" component={TeamPage} />
      <Route exact path="/pricing" component={Pricing} />
      <Route exact path="/pricing-mobile" component={PricingMobile} />
      <Route exact path="/discuss-project" component={DiscussProjectPage} />
      <Route path="/profit-margin-calculator" component={ProfitMarginPage} />
      <Route path="/project-planner" component={ProjectPlanner} />
      <Route path="/invoice-generator" component={InvoiceGeneratorPage} />
      <Route path="/content-creation" component={ContentRepurposingServices} />
      <Route path="/content-creation-confirmation" component={ThankYou} />
      <Route path="" component={NotFoundPage} />
    </Switch>
  );
}

export default App;
